import { Avatar } from "@material-ui/core";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Box, Tooltip } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import "../../App.css";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import InvitationFilterFromReport from "../../components/InvitationFilterFromReport";
import CustomStyleStatus from "../../components/statusStyleFormat/statusStyleFormat";
import Toast from "../../components/ToastContainer/CustomToast";
import { exportCheckoutVistorsLogs } from "../../services/Invitations/ExportService";
import { listInvitations } from "../../slices/Invitations/InvitationsSlice";
import CommonUtil from "../../Util/CommonUtils";
import SimpleDialogDemo from "../Approvals/ImageDailogBox";
import BlacklistVisitorForm from "../BlacklistVisitors/BlacklistVisitorForm";
import BlockVisitorIcon from "../Invitations/BlockVisitorIcon";
import CheckInProfile from "./CheckInProfile";
import ExportDialog from "./ExportDialog";

export default function CheckedOut() {
  const [clear, setClear] = React.useState(false);
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [totalRecords, setTotalRecords] = useState(1);
  const [rows, setRows] = useState([]);
  const [openBlacklistVisitor, setOpenBlacklistVisitor] = useState(false);
  const [blacklistId, setBlacklistId] = useState();
  const [del, setDel] = useState(false);
  const [pageSize, setPageSize] = useState(0);
  const [loading, setLoading] = useState(true);
  const companySettings = JSON.parse(localStorage.getItem("companySettings"));
  const [fileFormat, setFileFormat] = useState("1");
  const [noOfRecords, setNoOfRecords] = useState("0");
  const [inputValue, setInputValue] = useState("");
  const [toInputValue, setToInputValue] = useState("");
  const [isLivePhoto, setIsLivePhoto] = useState(false);
  const [isSignature, setIsSignature] = useState(false);
  const [closemodel, setClosemodel] = useState(false);
  const [visitorFirstName, setVisitorFirstName] = useState("");
  const [visitorLastName, setVisitorLastName] = useState("");

  const status = ["CHECKED_OUT"];

  const formatDayAndMonth = (numValue) => {
    if (numValue <= 0) {
      return "-" + (numValue + 12);
    }
    if (numValue < 10) {
      return "-0" + numValue;
    } else {
      return "-" + numValue;
    }
  };

  var today = new Date();
  var endDate =
    today.getFullYear() +
    formatDayAndMonth(today.getMonth() + 1) +
    formatDayAndMonth(today.getDate()) +
    "T23:59:59";
  var startDate =
    today.getFullYear() +
    formatDayAndMonth(today.getMonth() + 1) +
    formatDayAndMonth(today.getDate()) +
    "T00:00";

  const [paging, setPaging] = useState({
    page: 1,
    rowsPerPage: 50,
  });

  const [filter, setFilter] = React.useState({
    status: ["CHECKED_OUT"],
    visitorTypeId: "",
    siteId: "",
    firstName: "",
    lastName: "",
    scheduledStartDate: CommonUtil.formatToUtc(startDate),
    scheduledEndDate: CommonUtil.formatToUtc(endDate),
    visitMode: [
      "INVITATION",
      "WALKIN_REGISTARTION",
      "WALKIN_REGISTARTION_KIOSK",
      "SELF_REGISTARTION",
      "PRE_REGISTRATION",
    ],
    isPagable: true,
  });

  const defaultFilter = {
    status: ["CHECKED_OUT"],
    visitorTypeId: "",
    siteId: "",
    firstName: "",
    lastName: "",
    scheduledStartDate: CommonUtil.formatToUtc(startDate),
    scheduledEndDate: CommonUtil.formatToUtc(endDate),
    visitMode: [
      "INVITATION",
      "WALKIN_REGISTARTION",
      "WALKIN_REGISTARTION_KIOSK",
      "SELF_REGISTARTION",
      "PRE_REGISTRATION",
    ],
    isPagable: true,
  };

  const handleChange = (newPage, size) => {
    setLoading(true);
    setPage(newPage);
    setRowsPerPage(size);
    setPaging({
      page: newPage,
      rowsPerPage: size,
    });
  };

  useEffect(() => {
    loadData(filter, paging);
  }, [filter, paging, clear]);

  const handleOpen = () => {
    setOpen(true);
  };

  const resetFilter = () => {
    setLoading(true);
    setClear(false);
    setPaging({ ...paging, page: 1 });
    setFilter(defaultFilter);
  };

  const loadData = (filter, paging) => {
    dispatch(listInvitations(Object.assign(filter, paging)))
      .unwrap()
      .then((data) => {
        if ((data.code = "CVAI0000" && data.data)) {
          setLoading(false);
          setTotalRecords(data.data.totalCount);
          setRows(data.data.visits);
          setPage(data.data.curPage);
          setPageSize(data.data.pageSize);
          setTotalPages(data.data.totalPages);
        } else {
          setRows([]);
        }
      })
      .catch((er) => {});
  };
  useEffect(() => {
    if (del === true && parseInt(pageSize) !== 1) {
      loadData(filter, { page: page, rowsPerPage: rowsPerPage });
      setDel(false);
    } else {
      if (del === true) {
        setPaging({ page: page - 1, rowsPerPage: rowsPerPage });
        setDel(false);
      }
    }
  }, [del]);

  const handleFilter = (data) => {
    setLoading(true);
    setClear(true);
    setPaging({ ...paging, page: 1 });
    setFilter({
      siteId: data.siteId,
      visitorTypeId: data.visitorTypeId,
      visitMode: data.visitMode,
      firstName: data.firstName,
      lastName: data.lastName,
      scheduledStartDate: CommonUtil.formatToUtc(data.scheduledStartDate),
      scheduledEndDate: CommonUtil.formatToUtc(data.scheduledEndDate),
      status: status,
    });
  };

  const [date, setDate] = useState();

  const formatDate = (dateFormat) => {
    switch (dateFormat) {
      case "dd-MM-yyyy":
        return "dd-MM-yyyy HH:mm";
      case "MM-dd-yyyy":
        return "MM-dd-yyyy HH:mm";
      case "yyyy-MM-dd":
        return "yyyy-MM-dd HH:mm";
      default:
        return "yyyy-MM-dd HH:mm";
    }
  };

  const handleFileFormatChange = (event) => {
    setFileFormat(event.target.value);
  };

  const handleDataRecordsChange = (event) => {
    setNoOfRecords(event.target.value);
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    if (
      /^\d*$/.test(value) &&
      (value === "" ||
        (parseInt(value, 10) > 0 && parseInt(value, 10) <= 10000))
    ) {
      setInputValue(value);
    }
  };

  const handleToInputChange = (event) => {
    const value = event.target.value;
    if (
      /^\d*$/.test(value) &&
      (value === "" ||
        (parseInt(value, 10) > 0 && parseInt(value, 10) <= 10000))
    ) {
      setToInputValue(value);
    }
  };

  const handleCheckBoxLivePhoto = (event) => {
    setIsLivePhoto(event.target.checked);
  };
  const handleCheckBoxSignature = (event) => {
    setIsSignature(event.target.checked);
  };

  const handleCheckOutExport = (data) => {
    if (fileFormat == "2") {
      setIsLivePhoto(false);
      setIsSignature(false);
    }
    var searchParam = "";
    if (
      filter.firstName !== undefined &&
      !CommonUtil.isEmptyString(filter.firstName)
    ) {
      searchParam += "&firstName=" + encodeURIComponent(filter.firstName);
    }
    if (
      filter.lastName !== undefined &&
      !CommonUtil.isEmptyString(filter.lastName)
    ) {
      searchParam += "&lastName=" + encodeURIComponent(filter.lastName);
    }
    if (
      filter.scheduledStartDate !== undefined &&
      !CommonUtil.isEmptyString(filter.scheduledStartDate)
    ) {
      searchParam += "&scheduledStartDate=" + filter.scheduledStartDate;
    }
    if (
      filter.scheduledEndDate !== undefined &&
      !CommonUtil.isEmptyString(filter.scheduledEndDate)
    ) {
      searchParam += "&scheduledEndDate=" + filter.scheduledEndDate;
    }
    if (
      filter.visitorTypeId !== undefined &&
      !CommonUtil.isEmptyString(filter.visitorTypeId)
    ) {
      searchParam += "&visitorTypeId=" + filter.visitorTypeId;
    }
    if (
      filter.siteId !== undefined &&
      !CommonUtil.isEmptyString(filter.siteId)
    ) {
      searchParam += "&siteId=" + filter.siteId;
    }
    if (fileFormat !== "2") {
      searchParam += "&isLivePhoto=" + isLivePhoto;
      searchParam += "&isSignature=" + isSignature;
    } else {
      searchParam += "&isLivePhoto=" + false;
      searchParam += "&isSignature=" + false;
    }

    const stats = {
      status: "CHECKED_OUT",
      fileType: fileFormat,
      from: inputValue === "" ? "0" : inputValue,
      to: toInputValue === "" ? "0" : toInputValue,
    };

    dispatch(
      exportCheckoutVistorsLogs(onSuccess, onFailure, stats, searchParam),
    )
      .unwrap()
      .then((data) => {
        if ((data.code = "CVAI0000" && data.data)) {
          onSuccess();
        } else {
          onFailure();
        }
      })
      .catch((er) => {});
  };

  const onSuccess = () => {
    setClosemodel(true);
    return Toast(t("EXPORTSUCC001"), "success");
  };

  const onFailure = () => {
    Toast(t("COMMON000"), "error");
  };

  const totalduration = (params) => {
    let start = moment(params.row.checkIn);
    let end = moment(params.row.checkOut);
    let duration = moment.duration(end.diff(start));
    return (
      Math.floor(duration.asHours()) +
      moment.utc(duration.asMilliseconds() + 60000).format(":mm")
    );
  };

  const handleBlacklistVisit = (params) => {
    setOpenBlacklistVisitor(!openBlacklistVisitor);
    setVisitorFirstName(params.row.visitor.firstName);
    setVisitorLastName(params.row.visitor.lastName);
    setBlacklistId(params.row.id);
  };

  const handleTextOverflow = (text) => {
    if (text && text.length > 18) {
      return text.substring(0, 18) + "...";
    } else {
      return text;
    }
  };

  const renderCellScheduledStartDate = (date) => (params) => {
    const formattedDate = moment(
      CommonUtil.getLocalDateTimeInYearFormat(params.row.scheduledStartDate),
    ).format(
      date === "dd-MM-yyyy HH:mm"
        ? "DD-MM-YYYY HH:mm"
        : date === "MM-dd-yyyy HH:mm"
        ? "MM-DD-YYYY HH:mm"
        : date === "yyyy-MM-dd HH:mm"
        ? "YYYY-MM-DD HH:mm"
        : "",
    );
    return <span className="table-cell-trucate">{formattedDate}</span>;
  };

  const renderCellCheckIn = (date) => (params) => {
    const row = params.row || {};
    const checkIn = row.checkIn || null;
    if (!checkIn) return <span className="table-cell-trucate"></span>;
    const formattedDate = moment(
      CommonUtil.getLocalDateTimeInYearFormat(checkIn),
    ).format(
      date === "dd-MM-yyyy HH:mm"
        ? "DD-MM-YYYY HH:mm"
        : date === "MM-dd-yyyy HH:mm"
        ? "MM-DD-YYYY HH:mm"
        : date === "yyyy-MM-dd HH:mm"
        ? "YYYY-MM-DD HH:mm"
        : "",
    );
    return <span className="table-cell-trucate">{formattedDate}</span>;
  };

  const renderCellCheckOut = (date) => (params) => {
    const row = params.row || {};
    const checkOut = row.checkOut || null;
    if (!checkOut) return <span className="table-cell-trucate"></span>;
    const formattedDate = moment(
      CommonUtil.getLocalDateTimeInYearFormat(checkOut),
    ).format(
      date === "dd-MM-yyyy HH:mm"
        ? "DD-MM-YYYY HH:mm"
        : date === "MM-dd-yyyy HH:mm"
        ? "MM-DD-YYYY HH:mm"
        : date === "yyyy-MM-dd HH:mm"
        ? "YYYY-MM-DD HH:mm"
        : "",
    );
    return <span className="table-cell-trucate">{formattedDate}</span>;
  };

  const testBackGroundColors = [
    "#C7D4E7",
    "#F8EACD",
    "#DBE1D7",
    "#EBD3E1",
    "#E2DEED",
    "#EBD3D3",
    "#D7EEE8",
    "#D3F5D5",
    "#E5D9C3",
    "#D2C785",
    "#C6E0E3",
    "#E4D8EB",
    "#D0D1DC",
    "#CCE1D8",
    "#CBDAEC",
    "#F6FCE1",
    "#F6FCE1",
    "#DBD0CE",
    "#C3DFCF",
    "#E6D8E5",
    "#C3EBE1",
    "#C0E5F5",
    "#EBE3B1",
    "#F6CFCF",
    "#ECD4E9",
    "#D5F6CF",
    "#DAD9F5",
    "#F2E1CB",
  ];

  const textColors = [
    "#2D4568",
    "#6C5629",
    "#2F4B1C",
    "#491D37",
    "#20163B",
    "#572626",
    "#214C42",
    "#275E2B",
    "#7D6845",
    "#677820",
    "#29666D",
    "#4E2168",
    "#1E203A",
    "#194130",
    "#143F70",
    "#586E0C",
    "#392871",
    "#543935",
    "#395847",
    "#6D3969",
    "#085341",
    "#1E3C4A",
    "#3E380D",
    "#481515",
    "#381434",
    "#163610",
    "#13123E",
    "#30210E",
  ];

  const getAvatarColor = (name) => {
    const colors = [
      "#C7D4E7",
      "#F8EACD",
      "#DBE1D7",
      "#EBD3E1",
      "#E2DEED",
      "#EBD3D3",
      "#D7EEE8",
      "#D3F5D5",
      "#E5D9C3",
      "#D2C785",
      "#C6E0E3",
      "#E4D8EB",
      "#D0D1DC",
      "#CCE1D8",
      "#CBDAEC",
      "#F6FCE1",
      "#F6FCE1",
      "#DBD0CE",
      "#C3DFCF",
      "#E6D8E5",
      "#C3EBE1",
      "#C0E5F5",
      "#EBE3B1",
      "#F6CFCF",
      "#ECD4E9",
      "#D5F6CF",
      "#DAD9F5",
      "#F2E1CB",
    ];
    const index =
      name.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0) %
      colors.length;
    return colors[index];
  };

  const ZoomHandaler = (params) => {
    const { firstName, lastName, profilePhotoURL } = params.row.visitor;

    const getColorIndex = (name) => {
      const total = name
        .toUpperCase()
        .split("")
        .reduce((sum, char) => sum + char.charCodeAt(0), 0);
      return total % testBackGroundColors.length;
    };
    // Get initials
    const initials = `${firstName?.charAt(0) || ""}${lastName?.charAt(0) ||
      ""}`;
    const bgColor = !profilePhotoURL ? getAvatarColor(initials) : "transparent";
    const colorIndex = getColorIndex(initials);
    const textColor = profilePhotoURL ? "inherit" : textColors[colorIndex];

    return (
      <SimpleDialogDemo
        button={
          <Avatar
            onContextMenu={(e) => e.preventDefault()}
            style={{
              cursor: "pointer",
              backgroundColor: bgColor,
              color: textColor,
            }}
            alt={firstName}
            src={profilePhotoURL || undefined}
          >
            {!profilePhotoURL && initials.toUpperCase()}
          </Avatar>
        }
        child={
          <Avatar
            onContextMenu={(e) => e.preventDefault()}
            style={{
              width: "300px",
              height: "300px",
              border: "1px solid #FFFF",
              fontSize: "100px",
              borderRadius: "50%",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: bgColor,
              color: textColor,
            }}
            alt={firstName}
            src={profilePhotoURL || undefined}
          >
            {!profilePhotoURL && initials.toUpperCase()}
          </Avatar>
        }
      />
    );
  };

  const columns = React.useMemo(
    () => [
      {
        field: "visitor.profile",
        headerName: "",
        sortable: false,
        width: 10,
        renderCell: (params) => {
          return ZoomHandaler(params);
        },
      },
      {
        field: "visitor.firstName",
        headerName: t("COMMON014"),
        flex: 1,
        minWidth: 190,
        valueGetter: (params) =>
          params.row.visitor.lastName !== null
            ? params.row.visitor.firstName + " " + params.row.visitor.lastName
            : params.row.visitor.firstName,
        renderCell: (params) => (
          <Tooltip
            title={` ${
              params.row.visitor.lastName !== null
                ? params.row.visitor.firstName +
                  " " +
                  params.row.visitor.lastName
                : params.row.visitor.firstName
            }`}
            placement="bottom-start"
          >
            <span>
              {handleTextOverflow(
                params.row.visitor.lastName !== null
                  ? params.row.visitor.firstName +
                      " " +
                      params.row.visitor.lastName
                  : params.row.visitor.firstName,
              )}
            </span>
          </Tooltip>
        ),
      },

      {
        field: "visitor.email",
        headerName: t("PERSON005"),
        flex: 1,
        minWidth: 190,
        valueGetter: (params) => params.row.visitor.email,
        renderCell: (params) => (
          <Tooltip
            title={` ${params.row.visitor.email}`}
            placement="bottom-start"
          >
            <span>{handleTextOverflow(params.row.visitor.email)}</span>
          </Tooltip>
        ),
      },

      {
        field: "scheduledStartDate",
        headerName: t("INVITEDATELBL"),
        flex: 1,
        minWidth: 160,
        renderCell: renderCellScheduledStartDate(
          formatDate(companySettings.dateFormat),
        ),
      },

      {
        field: "checkIn",
        headerName: t("commonsCheckIn"),
        flex: 1,
        minWidth: 160,
        renderCell: renderCellCheckIn(formatDate(companySettings.dateFormat)),
      },
      {
        field: "checkOut",
        headerName: t("commonsCheckOut"),
        flex: 1,
        minWidth: 160,
        renderCell: renderCellCheckOut(formatDate(companySettings.dateFormat)),
      },

      {
        field: "duration",
        headerName: t("TOTAL_DURATION"),
        flex: 1,
        minWidth: 190,
        valueGetter: (params) =>
          params.row.checkOut && params.row.checkIn
            ? totalduration(params)
            : "",
      },

      {
        field: "status",
        headerName: t("COMMON001"),
        flex: 1,
        minWidth: 190,
        renderCell: (params) => {
          return <CustomStyleStatus row={params.row.status} icon={false} />;
        },
      },
      {
        field: "Actions",
        headerName: t("ACTION"),
        type: "actions",
        flex: 1,
        minWidth: 190,
        headerAlign: "center",
        getActions: (params) => [
          <CheckInProfile rowData={params.row} />,
          <Box onClick={() => handleBlacklistVisit(params)}>
            <BlockVisitorIcon />
          </Box>,
        ],
      },
    ],
    [companySettings.dateFormat],
  );

  return (
    <>
      <Box
        display={"flex"}
        width={"100%"}
        flexDirection={"row-reverse"}
        alignItems={"center"}
        style={{
          gap: "6px",
          padding: "10px 0px 8px 8px",
          marginTop: "60px",
        }}
      >
        <Box item>
          {clear && (
            <Link
              href="#"
              underline="hover"
              className="line"
              style={{
                opacity: "0.8",
                color: "#E3393C",
                fontSize: "14px",
                underline: "hover",
                display: "inline",
              }}
              onClick={resetFilter}
            >
              {t("CLEARFILTER")}
            </Link>
          )}
        </Box>

        <Box item>
          <ExportDialog
            rowsPerPage={rowsPerPage}
            applyFilter={(data) => handleCheckOutExport(data)}
            date={date}
            totalRecords={totalRecords}
            nameTitle={"Export Check Out"}
            handleFileFormatChange={handleFileFormatChange}
            handleDataRecordsChange={handleDataRecordsChange}
            handleInputChange={handleInputChange}
            handleToInputChange={handleToInputChange}
            fileFormat={fileFormat}
            noOfRecords={noOfRecords}
            inputValue={inputValue}
            toInputValue={toInputValue}
            setFileFormat={setFileFormat}
            setNoOfRecords={setNoOfRecords}
            setInputValue={setInputValue}
            setToInputValue={setToInputValue}
            setIsLivePhoto={setIsLivePhoto}
            setIsSignature={setIsSignature}
            isLivePhoto={isLivePhoto}
            isSignature={isSignature}
            handleCheckBoxLivePhoto={handleCheckBoxLivePhoto}
            handleCheckBoxSignature={handleCheckBoxSignature}
            closemodel={closemodel}
            setClosemodel={setClosemodel}
          />
        </Box>
        <Tooltip title={t("COMMON002")}>
          <Box item className="refreshIcon">
            <RefreshIcon onClick={() => loadData(filter, paging)} />
          </Box>
        </Tooltip>
        <Box item>
          <InvitationFilterFromReport
            rowsPerPage={rowsPerPage}
            selectedObject={filter.visitMode}
            applyFilter={(data) => handleFilter(data)}
            date={formatDate(companySettings.dateFormat)}
          />
        </Box>
      </Box>

      <div style={{ height: 300, width: "100%", marginTop: 10 }}>
        <DataTableLatest
          columns={columns}
          rows={rows}
          page={page}
          dailyReport={true}
          count={totalRecords}
          rowId={(row) => row.id}
          pageCount={totalPages}
          pageSize={rowsPerPage}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </div>

      {openBlacklistVisitor && (
        <BlacklistVisitorForm
          open={openBlacklistVisitor}
          handleClose={(data) => {
            loadData(filter, paging);
            setOpenBlacklistVisitor(data);
          }}
          disable={() => setDel(true)}
          BlacklistVisitorId={blacklistId}
          module={"Report"}
          subModule={"Daily Report Check Out"}
          blockListName={`${visitorFirstName}${
            visitorLastName ? " " + visitorLastName : ""
          }`}
        />
      )}
    </>
  );
}
